module.exports = __webpack_public_path__ + "static/fabric-table-loading-1de6c316ff3e73cbb7668c8515ec06b3.png";